<template>
    <div class="custList-box">
        <Form ref="search" :model="formItem" :label-width="100" label-colon="：">
            <Row>
                <Col :sm="{ span: 12}" :xl="{ span: 6}">
                    <FormItem label="客户名称">
                        <Input v-model="formItem.custName"></Input>
                    </FormItem>
                </Col>
                <Col :sm="{ span: 12}" :xl="{ span: 6}">
                    <FormItem label="客户法人">
                        <Input v-model="formItem.legalPerson"></Input>
                    </FormItem>
                </Col>
                <Col :sm="{ span: 24}" :xl="{ span: 12}" class="search-btn">
                    <Button type="primary" @click="getCustList()">搜索</Button>
                    <Button style="margin-left: 8px" @click="clearSearch()">清空</Button>
                    <Button style="margin-left: 8px" type="success" @click="createNewCust()">添加客户</Button>
                </Col>
            </Row>
        </Form>
        <div ref="showTable" class="custList-table">
            <Table :columns="columns" :data="tableData" :height="THeight" border></Table>
        </div>
        <div ref="page" class="custList-page"><Page :current="page" :page-size="limit" :total="total" show-sizer @on-change="pagechange($event)" @on-page-size-change="pageNumchange($event)" /></div>
        <custDetail :control="detailModal.show" :custId="detailModal.id.toString()" :custTitle="detailModal.title" @changeControl="changeShow($event)"></custDetail>
        <custCreateAndEdit :createShow="createModal.show" :createId="createModal.id.toString()" :createTitle="createModal.title" @createShowChange="createShowChange($event)"></custCreateAndEdit>
    </div>
</template>
<script>
import custDetail from '../../components/cust/custDetail';
import custCreateAndEdit from '../../components/cust/custCreateAndEdit';
import api from '@/api/index';

export default {
    components: {
        custDetail,
        custCreateAndEdit
    },
    data() {
        return {
            columns: [
                {
                    title: '客户名称',
                    key: 'custName'
                },
                {
                    title: '注册资金',
                    width: 160,
                    key: 'registerCapital'
                },
                {
                    title: '法人',
                    align: 'center',
                    width: 120,
                    key: 'legalPerson'
                },
                {
                    title: '是否上市',
                    key: 'listed',
                    align: 'center',
                    width: 120,
                    render: (h, params) => {
                        if (params.row.listed) {
                            return h('div', '是');
                        } else {
                            return h('div', '否');
                        }
                    }
                },
                {
                    title: '业务范围',
                    minWidth: 240,
                    key: 'businessScope'
                },
                {
                    title: '备注',
                    key: 'industry'
                },
                {
                    title: '注册货币类型',
                    align: 'center',
                    width: 140,
                    key: 'currencyType'
                },
                {
                    title: '操作',
                    key: 'address',
                    align: 'center',
                    width: 180,
                    render: (h, params) => {
                        return h('div', [
                            h('Button', {
                                props: { size: 'small' },
                                style: { marginRight: '5px' },
                                on: {
                                    click: () => {
                                        this.detailModalShow(params.row);
                                    }
                                }
                            }, '查看'),
                            h('Button', {
                                props: { type: 'primary', size: 'small' },
                                style: { marginRight: '5px' },
                                on: {
                                    click: () => {
                                        this.editCust(params.row);
                                    }
                                }
                            }, '编辑'),
                            h('Button', {
                                props: { type: 'error', size: 'small' },
                                on: {
                                    click: () => {
                                        this.deleteCust(params.row);
                                    }
                                }
                            }, '删除')
                        ]);
                    }
                }
            ],
            tableData: [],
            formItem: {
                custName: '',
                legalPerson: ''
            },
            THeight: 100,
            detailModal: {
                show: false,
                title: '',
                id: ''
            },
            createModal: {
                show: false,
                title: '',
                id: ''
            },
            page: 1,
            limit: 10,
            total: 0,
            timer: ''
        };
    },
    mounted() {
        this.fixedTable();
        this.getCustList();
        this.windowOnresize();
    },
    methods: {
        fixedTable() {
            const pTop = this.$refs.search.$el.clientHeight;
            const pBottom = this.$refs.page.clientHeight;
            this.$refs.showTable.style.top = pTop + 'px';
            this.$refs.showTable.style.bottom = pBottom + 'px';
            this.THeight = this.$refs.showTable.clientHeight - 10;
        },
        windowOnresize() {
            window.onresize = () => {
                window.clearTimeout(this.timer);
                this.$refs.showTable.style.overflow = 'hidden';
                return (() => {
                    this.timer = setTimeout(() => {
                        this.fixedTable();
                        this.$refs.showTable.style.overflow = 'visible';
                    }, 100);
                })();
            };
        },
        async getCustList() {
            const res = await api.getustList(this.limit, this.page, this.formItem.custName, this.formItem.legalPerson);
            if (res.code !== 200) {
                return;
            }
            this.total = res.data.total;
            this.tableData = res.data.resultList;
        },
        clearSearch() {
            this.formItem.custName = '';
            this.formItem.legalPerson = '';
            this.getCustList();
        },
        detailModalShow(data) {
            this.detailModal.title = data.custName;
            this.detailModal.id = data.custID;
            this.detailModal.show = true;
        },
        changeShow(val) {
            this.detailModal.show = val;
        },
        createNewCust() {
            this.createModal.title = '新客户创建';
            this.createModal.id = '';
            this.createModal.show = true;
        },
        editCust(data) {
            this.createModal.title = '编辑客户 -';
            this.createModal.id = data.custID;
            this.createModal.show = true;
        },
        createShowChange(val) {
            this.createModal.show = val;
        },
        deleteCust(data) {
            this.$Modal.confirm({
                title: '删除客户确认',
                content: '确定删除客户 - ' + data.custName,
                onOk: () => {
                    this.$Message.info('确定删除');
                },
                onCancel: () => {
                    this.$Message.info('取消删除');
                }
            });
        },
        pagechange(num) {
            this.page = num;
            this.getCustList();
        },
        pageNumchange(num) {
            this.limit = num;
            this.getCustList();
        }
    }
};
</script>

<style lang="scss" scoped>
.custList-box {
    height: 100%;
    overflow: hidden;
    position: relative;
}
.custList-table {
    position: absolute;
    left: 0;
    right: 0;
}
.search-btn {
    text-align: right;
}
.custList-page {
    position: absolute;
    bottom: 0;
}
</style>
<style scoped>
.custList-box >>> .ivu-form-item {
    margin-bottom: 10px;
}
</style>
